// Inquiry slice — owns the final "Send Inquiry" submission. The form data
// (contact, area, selections) lives in other slices; this slice only tracks the
// submit lifecycle and the support email returned on success.
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../api/public-client.js';

export const submitInquiry = createAsyncThunk(
  'inquiry/submit',
  async ({
    geometryToken, selections, detailsText, displayGeoJson,
  }, { rejectWithValue }) => {
    try {
      return await apiFetch('/api/intake/inquiry', {
        method: 'POST',
        body: {
          geometryToken, selections, detailsText, displayGeoJson,
        },
      });
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const initialState = {
  submitting: false,
  submitted: false,
  error: null,
};

const inquirySlice = createSlice({
  name: 'inquiry',
  initialState,
  reducers: {
    resetInquiry: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitInquiry.pending, (s) => {
        s.submitting = true;
        s.error = null;
      })
      .addCase(submitInquiry.fulfilled, (s) => {
        s.submitting = false;
        s.submitted = true;
      })
      .addCase(submitInquiry.rejected, (s, a) => {
        s.submitting = false;
        s.error = a.payload || 'Failed to send your inquiry. Please try again.';
      });
  },
});

export const { resetInquiry } = inquirySlice.actions;
export default inquirySlice.reducer;
